import { axios } from 'libs';

const resource = '/processos-arquivos-zip';

export const gerarZip = (dto, processoId) => {
  return axios.post(`${resource}/gerar${processoId}`, dto);
};

export const consultarSituacaoZip = processoId => {
  return axios.get(`${resource}/situacao${processoId}`);
};
